<template>
    <div class="Summary">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Child Info</h4>
                        <p><span class="bold">Name: </span><span>{{ ChildRecordData.Client.Person.FirstName }}</span> <span v-if="ChildRecordData.Client.Person.AKA">"{{ ChildRecordData.Client.Person.AKA }}"</span> <span>{{ ChildRecordData.Client.Person.LastName }}</span></p>
                        <p><span class="bold">DOB: </span><span>{{ formatDate(ChildRecordData.Client.Person.DOB, 'MM/DD/YY') }}</span></p>
                        <p><span class="bold">Age: </span><span>{{ ChildRecordData.Client.Person.AgeString }}</span></p>
                        <p><span class="bold">Sex: </span><span>{{ ChildRecordData.Client.Person.Sex.Name }}</span></p>
                    </div>
                    
                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Team</h4>
                        <div v-if="CurrentTeamMembers">
                            <p><span class="bold">Assigned Team: </span><span>{{ CurrentTeamMembers.TeamName }}</span></p>
                            <p><span class="bold">Facilitator: </span><span>{{ CurrentTeamMembers.Facilitator }}</span></p>
                            <p><span class="bold">BHS: </span><span>{{ CurrentTeamMembers.BHS }}</span></p>
                            <p><span class="bold">Parent Partner: </span><span>{{ CurrentTeamMembers.PP }}</span></p>
                            <p><span class="bold">Clinician: </span><span>{{ CurrentTeamMembers.Clinician }}</span></p>
                            <p><span class="bold">Additional Support: </span><span>{{ CurrentTeamMembers.Support }}</span></p>
                        </div>
                        <div v-else>
                            <p><span class="bold red">Client is pending a team assignment.  Assign the client to a Team in the Team Tab.</span></p>
                        </div>
                    </div>
                    
                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Living Situation</h4>
                        <div v-if="CurrentLivingSituation">
                            <p><span class="bold">Description: </span><span>{{ CurrentLivingSituation.InformalDescription }}</span></p>
                            <p><span class="bold">Type: </span><span>{{ CurrentLivingSituation.SituationType }}</span></p>
                            <p><span class="bold">Address: </span><span>{{ CurrentLivingSituation.Address.AddressSingleLine }} </span><GoogleMapsLink v-bind:address="CurrentLivingSituation.Address" /></p>
                        </div>
                        <div v-else>
                            <p><span class="bold red">No Living Situation Added.  Add Living Situation in the Program Tab.</span></p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Program Enrollment</h4>
                        <p><span class="bold">Regional Program: </span><span>{{ ChildRecordData.SubProgram.Name }}</span></p>
                        <p><span class="bold">Placement Agency: </span><span>{{ ChildRecordData.PlacementAgency.Name }} </span></p>
                        <p><span class="bold">Referral: </span><span>{{ formatDate(ChildRecordData.StartDate, 'MM/DD/YY') }}</span></p>
                        <p><span class="bold">First F2F: </span><span>{{ formatDate(ChildRecordData.FirstFaceToFaceDate, 'MM/DD/YY', '') }}</span></p>
                        <p><span class="bold">Discharge: </span><span>{{ formatDate(ChildRecordData.EndDate, 'MM/DD/YY', '') }}</span></p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
            CurrentTeamMembers: function () {
                let output = {
                    TeamName: "Unassigned",
                    BHS: "Unassigned",
                    Facilitator: "Unassigned",
                    PP: "Unassigned",
                    Clinician: "Unassigned",
                    Support: ""
                };
                let teams = this.ChildRecordData.WraparoundTeamMemberships.filter(r => r.EndDate == null);
                if (teams.length == 1) {
                    output.TeamName = teams[0].WraparoundTeam.Name;
                }
                let bhsList = this.ChildRecordData.EmployeeCaseloads.filter(r => r.EndDate == null && r.EmployeeRole == "Behavioral Health Specialist");
                if (bhsList.length > 0) {
                    output.BHS = bhsList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let facilitatorList = this.ChildRecordData.EmployeeCaseloads.filter(r => r.EndDate == null && r.EmployeeRole == "Facilitator");
                if (facilitatorList.length > 0) {
                    output.Facilitator = facilitatorList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let ppList = this.ChildRecordData.EmployeeCaseloads.filter(r => r.EndDate == null && r.EmployeeRole == "Parent Partner");
                if (ppList.length > 0) {
                    output.PP = ppList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let clinicianList = this.ChildRecordData.EmployeeCaseloads.filter(r => r.EndDate == null && r.EmployeeRole == "Clinician");
                if (clinicianList.length > 0) {
                    output.Clinician = clinicianList.map(e => e.Employee.Person.FullName).join(', ');
                }
                let supportList = this.ChildRecordData.EmployeeCaseloads.filter(r => r.EndDate == null && r.EmployeeRole == "Support");
                if (supportList.length > 0) {
                    output.Support = supportList.map(e => e.Employee.Person.FullName).join(', ');
                }

                return output;
                
            },
            CurrentLivingSituation: function () {
                let livingSituations = this.ChildRecordData.LivingSituations.filter(r => r.EndDate == null);
                if (livingSituations.length == 1) {
                    return livingSituations[0];
                } else {
                    return null;
                }

            }
        }
    }
</script>

<style scoped>
</style>